import React from "react";
import {Box} from "@mui/material";
import {GraphQlDataGrid} from "../../../../components/common/grid/GraphQlDataGrid";
import {graphQLServices} from "../../../../services/GraphQLServices";
import {GridFilterItem} from "@mui/x-data-grid/models/gridFilterItem";
import {translateFunction} from "../../../../localization/TranslationService";
import {GET_LOOKUPS} from "../graphql/queries/gqlGetLookups";

const translate = translateFunction();

interface ILookup {
	onRowClick?: (row: any) => void;// GridEventListener<"rowClick">;
	defaultFilter?: GridFilterItem[];
	type: string;
	hideCode?: boolean;
	autoSelectSingleRecord?: boolean;
}

const defaultFilter = [
	{
		field: "code",
		operator: "equals",

	},
	{
		field: "description",
		operator: "startsWith",
	},

];

export const Lookup: React.FC<ILookup> = (props) => {

	const filter = defaultFilter.filter((it) => props.defaultFilter &&  (props.defaultFilter.filter((x) => x.field === it.field  ).length === 0));

	return (
		<Box>

			<GraphQlDataGrid
				infiniteLoading={true}
				hideExportButton
				gridHeight={800}
				enableHeaderFilter
				client={graphQLServices.documentsClient}
				query={	GET_LOOKUPS }
				defaultSortModel={[
					{
						field: "description",
						sort: "asc"
					}
				]}
				defaultFilterModel={{
					items: [...filter??[],...props.defaultFilter??[]]
				}}
				columnVisibilityModel={{code: !props.hideCode}}
				columns={[
					{
						field: "code",
						headerName: translate("Code"),

						width: 150,
						sortable: false,
						type: "string",

					},
					{
						field: "description",
						headerName: translate("Description"),
						width: 400,
						sortable: true,
					}
				]}
				graphFunction={
					"lookups"
				}
				onDataFetched={(items) => {
					if (items.length === 1) {
						//const params: GridRowParams<any> = items[0];
						// TODO auto select if 1 item, issue with this line is that search button is not working anymore
						//props.onRowClick && props.onRowClick(items[0]);
					}
				}}
				queryVariables={{"type": props.type}}
				rows={[]}
				getRowId={(item:any)=> item.code}
				initialPageSize={200}
				rowsPerPageOptions={[200]}
				//autoHeight={true}
				//disableColumnFilter
				//disableColumnMenu
				onRowClick={(params) => props.onRowClick && props.onRowClick(params.row)}
				autoSelectSingleRecord={props.autoSelectSingleRecord}
				onAutoSelect={(row) => props.onRowClick && props.onRowClick(row)}
			/>

		</Box>
	);
};
